
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'submitButton': {'marginTop': `16px`,},'sq-fieldset': {'backgroundColor': `#4b4b4b`,},'squareInputStyles': {'backgroundColor': `transparent`,'color': `#ffffff`,'fontSize': `16px`,'lineHeight': `24px`,'padding': `16px`,},'formContainer': {'margin': `20px 0`,},
        
      };
    };
  